export default __webpack_public_path__ + "static/mokuPopup-1f4b7ac81b03dbb9d4ba5291a24eb13a.svg";